<template>
    <b-form class="step-form" @submit.stop.prevent="onSubmit">
        <b-modal
            ref="modalError"
            size="md"
            title="Welcome to Idenfo Direct"
            hide-footer
            hide-header-close
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
        >
            <div class="modal-body-disclaimer">
                <p class="paragraph">
                    Hi
                    <span style="text-transform: capitalize">{{
                        user.firstName
                    }}</span
                    >! <br /><br />
                    <!--It looks like you've hit the limit on the number of profiles-->
                    <!--included in your current pricing plan :( To continue to-->
                    <!--onboard another profile, you will have to purchase the next-->
                    <!--package. Would you like to upgrade now?-->
                    To begin onboarding and verifying profiles with your Idenfo
                    Direct account, please subscribe to one of our flexible
                    pricing packages.
                </p>
                <div class="row justify-content-center">
                    <div class="m-2">
                        <b-button v-if="country!='Pakistan'" variant="primary" @click="payments"
                            >Plans</b-button
                        >
                    </div>
                    <div class="m-2">
                        <b-button variant="secondary" @click="currentPlan"
                            >Cancel</b-button
                        >
                    </div>
                </div>
            </div>
        </b-modal>
        <div v-if="!showPageLoader" class="row">
            <div class="col-lg-12">
                <p class="info mb-4">
                    <i class="icon-error_outline"></i>Hello user, once you press
                    the SEND LINK button at the bottom, a link to this form will
                    be sent to the following email :
                    <strong>{{
                        this.$store.state.registration.form.contactInfo.email
                    }}</strong>
                    .
                </p>
                <div class="row">
                    <template v-for="(field, index) in fields">
                         <!-- Company Fetch Fields -->
                         <template v-if="route.includes('register-company') && showCompanyFeature && index == 0">
                            <company-auto-fill :fields="fields"></company-auto-fill>
                        </template>
                        <!-- Company Fetch Fields End -->
                        <div
                           
                            :key="index"
                            :class="{
                                [field.class]: true,
                                'col-lg-12': field.type == 'heading',
                                'col-md-4':
                                    field.type !== 'heading' && !field.class,
                                'col-md-8':
                                    (index == 4 || index == 6) &&
                                    section == 'account-info',
                                    'col-md-5':
                                    (field.key == 'identityInfo.number'  || field.key == 'identityInfo.passport.number' ) &&
                                    section == 'setup-profile',
                            }"
                        >
                            <div
                                v-if="field.type == 'heading' && index > 0"
                                class="form-border"
                            ></div>

                            <component
                                :is="field.type"
                                :field="field"
                                :data-segment-id="dataSegmentId"
                            ></component>
                        </div>
                        <!-- Address Fetch Fields -->
                        <!-- <template v-if="showAddressFeature && field.type == 'heading' && field.title=='Contact Information'">
                            <address-auto-fill :fields="fields"></address-auto-fill>
                        </template> -->
                        <!-- Address Fetch Fields End -->
                    </template>
                    <div class="col-lg-12"><div class="form-border"></div></div>
                </div>
                <base-button
                    btn-type="submit"
                    btn-variant="primary"
                    btn-label="SEND LINK"
                    class="mr-3"
                    :class="loading ? 'disabled' : ''"
                    :disabled="loading"
                ></base-button>
                <span v-if="loading" class="secondary-color">
                    Please wait. We're processing your request...</span
                >
            </div>
        </div>
        <!-- When data is loading -->
        <base-table-spinner v-if="showPageLoader"></base-table-spinner>
    </b-form>
</template>
<script>
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'

import request from '@/utils/request'

import Heading from '@/components/registration/Heading.vue'
import TextField from '@/components/registration/TextField.vue'
import TextArea from '@/components/registration/TextArea.vue'
import DatePicker from '@/components/registration/DatePicker.vue'
import List from '@/components/registration/List.vue'
import Dropdown from '@/components/registration/Dropdown.vue'
import Radio from '@/components/registration/Radio.vue'
import Checkbox from '@/components/registration/Checkbox.vue'
// import PhoneNumber from '@/components/registration/PhoneNumberWithoutValidation.vue'
import PhoneNumber from '@/components/registration/PhoneNumber.vue'
import IdentityType from '@/components/registration/IdentityType.vue'
import IdentityDocumentExpiry from '@/components/registration/IdentityDocumentExpiry.vue'
import Country from '@/components/registration/Country.vue'
import Nationality from '@/components/registration/Nationality.vue'
import TaxId from '@/components/registration/TaxId.vue'
import WorkType from '@/components/registration/WorkType.vue'
import Industry from '@/components/registration/Industry.vue'
import OtherNationalities from '@/components/registration/OtherNationalities'
import MultiTextField from '@/components/registration/MultiTextField.vue'
import MultiSelect from '@/components/registration/MultiSelect.vue'
import MultiSelectOld from '@/components/registration/MultiSelectOld.vue'
import FileInput from '@/components/registration/FileInput.vue'
import AddressAutoFill from '@/components/AddressAutoFill.vue'
import CompanyAutoFill from '@/components/CompanyAutoFill.vue'

// const apiUrl = process.env.VUE_APP_API_URL
// import axios from 'axios'

import resource from '@/api/resource'
const dataSegmentApi = new resource('users/data-segment')

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        CompanyAutoFill,
        AddressAutoFill,
        Heading,
        TextField,
        TextArea,
        DatePicker,
        List,
        Dropdown,
        Radio,
        Checkbox,
        PhoneNumber,
        IdentityType,
        IdentityDocumentExpiry,
        Country,
        Nationality,
        TaxId,
        WorkType,
        Industry,
        OtherNationalities,
        MultiTextField,
        MultiSelect,
        MultiSelectOld,
        FileInput
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            section: 'setup-profile',
            fields: [],
            showPageLoader: true,
            counter: null,
            subscription: null,
            tier: null,
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                status: null,
                sortBy: 'idenfoId',
                sortOrder: 'desc',
            },
            path: 'users/temp-applications',
            resourceApi: null,
            deepLinkRegisteredCount: 0,
            selfRegisteredCount:0,
            country : process.env.VUE_APP_COUNTRY,
            showAddressFeature: process.env.VUE_APP_AUTO_ADDRESS_FILL == 'true',
            showCompanyFeature: process.env.VUE_APP_AUTO_FILL_COMPANY == 'true'

        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapState({
            restrictDuplicateCustomers: (state) =>
                state.registration.restrictDuplicateCustomers,
        }),

        ...mapGetters([
            'loading',
            'dataSegmentId',
            'user',
            'hasScopes',
            'dataSegmentList',
        ]),
        route(){
          return this.$route.path
        },
        // dataSegmentId() {
        //     if (this.$route.params.dataSegmentId) {
        //         return this.$route.params.dataSegmentId
        //     }
        //     return this.$store.getters.dataSegmentId
        // },
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.getRecords()
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    async mounted() {
        this.getCounter()
        await this.getRecords()
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        checkField(field)
        {
            let excludeFields = ['occupationInfo.relationshipStartDate',
                'enhancedDueDiligence','accountInfo.enhancedDueDiligence.dateOfEdd',
                'accountInfo.enhancedDueDiligence.isScrutinyPerformed','accountInfo.enhancedDueDiligence.isCustBusInquired',
                'accountInfo.enhancedDueDiligence.isManagementApproval','accountInfo.enhancedDueDiligence.isFirstPayment',
                'accountInfo.enhancedDueDiligence.scrutinyRemarks','accountInfo.enhancedDueDiligence.custBusInquiredRemarks',
                'accountInfo.enhancedDueDiligence.managementApprovalRemarks','accountInfo.enhancedDueDiligence.firstPaymentRemarks',
                'documentInfo.scrutiny.fileName','documentInfo.custBusInquired.fileName','documentInfo.managementApproval.fileName',
                'documentInfo.firstPayment.fileName',
                'strInformation','accountInfo.isStr','accountInfo.strDate','accountInfo.strReason','faceToFaceDeclaration','accountInfo.isf2f']
            const fieldFound = excludeFields.find(fieldObj => fieldObj === field.key);
            if(fieldFound)
            {
                return false
            }
            if(field.status && field.status=='active')
            {
                if(field.visibleTo && field.visibleTo.indexOf('company') > -1)
                {
                    return true
                }
            }
            return false
        },
        async getCounter() {
            this.$store.commit('showPageLoader', true)
            try {
                let dataSegment = await dataSegmentApi.get(this.dataSegmentId)
                this.resourceApi = new resource('users/count-applications')
                let params = {
                    dataSegmentId: dataSegment.data.data._id
                }
                let { data } = await this.resourceApi.list(params)
                if (data && data.tierAttains) {
                    this.$refs.modalError.show()
                }
                // False the page loader after the list has been loaded
                this.$store.commit('showPageLoader', false)
                this.$store.commit('setLoading', false)

            } catch (error) {
                this.$store.commit('showPageLoader', false)
                this.$store.commit('setLoading', false)
                // this.$store.commit('setError', error)
            }
        },
        /*
         *
         * Get Deep Link Data
         *
         */
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        async onSubmit() {
            // const result = true
            this.$analytics.fbq.event('SendDeeplinkClick')

            console.log('FORM DATA')
            console.log(this.$store.state.registration.form)

            const result = await this.$validator.validateAll()
            // Check if validation fails
            if (result) {
                this.$store.commit('setLoading', true)
                let registrationUrl = '/customers/save-customer'
                try {
                    // this.$store.commit('updateField', {
                    //     key: 'identityInfo.type',
                    //     value: 'id',
                    // })

                    const formData = this.$store.state.registration.form
                    formData.dataSegmentId = this.dataSegmentId
                    formData.type='company'

                    let encryptedForm = this.$encrypt(formData)
                    console.log('Encryption: ' + encryptedForm)
                    const tempRequest = { data: encryptedForm }
                    const { data } = await request({
                        url: registrationUrl,
                        method: 'post',
                        data: tempRequest,
                    })

                    this.$store.commit('updateField', {
                        key: 'idenfoId',
                        value: data.data.idenfoId,
                    })

                    this.$router.push('/register-company/finish')

                } catch (errors) {
                    // console.log("catch + " , errors)
                    this.$store.commit('setError', errors)
                    // this.$refs.modalError.show()
                }
                this.$store.commit('setLoading', false)
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method

        /**
         * get the form fields when required
         *
         * @return {void}
         */
        async getRecords() {
            try {
                let { data } = await request({
                    url: `/form-builder/`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        section: this.section,
                        isEdit:false,
                        type:"company",
                    
                    },
                })
                this.fields = data.data.map(el=> {
                                    if(!['contactInfo.email', 'contactInfo.confirmEmail', 'basicInfo.firstName'].includes(el.key)) {
                                        el.isRequired = false;
                                    }
                                    return el
                                })
                this.showPageLoader = false
                this.fields = data.data
            } catch (error) {}
            this.$store.commit('setLoading', false)
        }, // End of getRecords() method
        payments() {
            this.$refs.modalError.hide()
            this.$router.push('/billing')
        },
        currentPlan() {
            this.$refs.modalError.hide()
            this.$router.push('/customer-profiles')
        },
    }, // End of Component > watch
} // End of export default
</script>
